import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProFirstReplyConfirmView のスタイル
 */
export const hotlineProFirstReplyConfirmViewStyle = tv({
    slots: {
        bottomContent: ['flex flex-col gap-16 lg:gap-40', 'mt-8 lg:mt-24'],
        fieldWrap: ['pt-28 pb-32 px-16 lg:p-32'],
        list: ['flex flex-col lg:gap-24'],
    },
    variants: {},
});
